/**
 * serverClock — iter265. Client clock synced to the SERVER so time-gated UI
 * (RSVP opens at exactly 5:00 PM) unlocks on server time, immune to a phone
 * clock that runs seconds fast/slow.
 *
 * Usage: import { serverNow, syncServerClock } from '../lib/serverClock';
 *        const nowMs = serverNow(); // Date.now() + measured offset
 */
import axios from 'axios';

let offsetMs = 0;
let synced = false;
let syncing = null;

export async function syncServerClock() {
  if (syncing) return syncing;
  syncing = (async () => {
    try {
      const t0 = Date.now();
      const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/time`, { timeout: 5000 });
      const t1 = Date.now();
      const rtt = t1 - t0;
      // Server timestamp corresponds to roughly the midpoint of the round trip
      offsetMs = res.data.epoch_ms + rtt / 2 - t1;
      synced = true;
    } catch {
      offsetMs = 0; // fall back to device clock
    } finally {
      syncing = null;
    }
  })();
  return syncing;
}

export function serverNow() {
  if (!synced && !syncing) syncServerClock();
  return Date.now() + offsetMs;
}

export function isServerSynced() {
  return synced;
}
